module.exports = __webpack_public_path__ + "img/news_okazukan.498cb2c9.png";